export default __webpack_public_path__ + "static/media/customer_ob_on.f541ed8e.svg";